// Shared color/tier scheme for "% da meta" badges — used by FranchiseReportsV2
// (GoalBar, TopUnitsRanking) and FranchiseReportVisualization (Ranking de
// Unidades). `p` is a 0-100 percent number, not a 0-1 fraction.
//
// Faixas: 0-40 vermelho | 41-60 amarelo | 61-80 verde claro | 81-99 verde escuro | 100+ meta batida
export const getMetaTier = (p) => {
  if (p >= 100) return 5;
  if (p >= 81) return 4;
  if (p >= 61) return 3;
  if (p >= 41) return 2;
  return 1;
};

export const getMetaBadgeClass = (p) => {
  if (p >= 100) return 'bg-green-200 text-green-900';
  if (p >= 81)  return 'bg-green-100 text-green-700';
  if (p >= 61)  return 'bg-emerald-50 text-emerald-600';
  if (p >= 41)  return 'bg-yellow-100 text-yellow-700';
  return 'bg-red-100 text-red-700';
};

export const getMetaBadgeLabel = (p) => (p >= 100 ? `Meta Batida • ${p.toFixed(2)}%` : `${p.toFixed(2)}%`);

export const getMetaCardTheme = (p) => {
  if (p >= 100) return { bg: 'bg-green-50', border: 'border-green-200', label: 'text-green-500', value: 'text-green-700', sub: 'text-green-500', msg: 'Meta Batida' };
  if (p >= 81)  return { bg: 'bg-green-50', border: 'border-green-200', label: 'text-green-500', value: 'text-green-700', sub: 'text-green-500', msg: 'Quase lá' };
  if (p >= 61)  return { bg: 'bg-emerald-50', border: 'border-emerald-200', label: 'text-emerald-500', value: 'text-emerald-700', sub: 'text-emerald-500', msg: 'Em desenvolvimento' };
  if (p >= 41)  return { bg: 'bg-yellow-50', border: 'border-yellow-200', label: 'text-yellow-500', value: 'text-yellow-700', sub: 'text-yellow-500', msg: 'Alerta' };
  return { bg: 'bg-red-50', border: 'border-red-200', label: 'text-red-400', value: 'text-red-600', sub: 'text-red-400', msg: 'Atenção Necessária' };
};

export const getMetaTierHexColor = (p) => {
  if (p >= 100) return '#22c55e'; // green-500
  if (p >= 81)  return '#86efac'; // green-300
  if (p >= 61)  return '#34d399'; // emerald-400
  if (p >= 41)  return '#eab308'; // yellow-500
  return '#ef4444'; // red-500
};
